import React, { useEffect, useState } from 'react';
import { NumericFormat } from 'react-number-format';

const defaultMinValue: string = '-9999999';
const defaultMinValueMainasu: string = '-9999998'; //マイナスのみの入力の場合

type Props = {
  value: number;
  /**
   * 小数以下の設定
   * 0の場合小数点入力不可
   */
  decimalScale?: number;
  /**
   * true を指定すると、小数点以下の桁数が常に0で表示
   */
  fixedDecimalScale?: boolean;
  /**
   * 入力最小値
   */
  minValue?: number;
  /**
   * 入力最大値
   */
  maxValue?: number;
  /**
   * true の場合、負数の入力を許可します。
   */
  allowNegative?: boolean;
  /**
   * スタイル
   */
  className?: string;

  /**
   * 変更event
   */
  onChange?: (value: number) => void;
};

/**
 * 入力値を判定して文字列として返す
 * -だけだった場合
 * 空だった場合
 * 数字ではなかった場合
 * @param value
 * @returns
 */
const checkValueConvert = (value: string): string => {
  let setV: string;
  if (value === '-') {
    setV = defaultMinValueMainasu;
    //console.debug(['mainasu a Number', setV]);
  } else if (value === '') {
    setV = defaultMinValue;
    //console.debug(['null a Number', props.minValue ?? 0]);
  } else {
    const numValue = Number(value);
    if (isNaN(numValue)) {
      setV = defaultMinValue;
      //console.debug(['Not a Number', props.minValue ?? 0]);
    } else {
      //console.debug(['Set Number', numValue]);
      setV = String(numValue);
    }
  }
  return setV;
};

/**
 * 数値入力用コンポーネント
 * @param props
 * @returns
 */
const NumericFormatEntry_input: React.FC<Props> = (props: Props) => {
  const [val, setVal] = useState<string>(String(props.value));

  useEffect(() => {
    setVal(checkValueConvert(String(props.value)));
  }, [props.value]);

  useEffect(() => {
    //console.debug(['- useEffect - NumericFormatEntry_input', props]);
    //入力値表示更新の為0をセットした値を再セットしてレンダリングする
    if (val === defaultMinValue) {
      setVal(props.minValue == null ? '0' : String(props.minValue));
    } else if (val === defaultMinValueMainasu) {
      setVal('-');
    }
  }, [val]);

  return (
    <>
      <NumericFormat
        decimalScale={props.decimalScale ?? 0}
        fixedDecimalScale={props.fixedDecimalScale ?? false}
        value={val}
        allowNegative={props.allowNegative ?? false}
        thousandSeparator={false}
        isAllowed={(values) => {
          const numValue = Number(values.value);
          if (isNaN(numValue)) return true;
          return numValue >= (props.minValue ?? -9999999) && numValue <= (props.maxValue ?? 9999999);
        }}
        onBlur={(e) => {
          if (props.onChange) {
            if (val === '-') {
              setVal('0');
              props.onChange(0);
            } else {
              props.onChange(Number(val));
            }
          }
        }}
        onValueChange={(values, sourceInfo) => {
          //console.debug(['values.value', values.value]);
          //console.debug(['values.formattedValue', values.formattedValue]);
          //console.debug(['values.floatValue', values.floatValue]);
          let setV = checkValueConvert(values.value);
          setVal(setV);
        }}
        className={props.className ?? ''}
        onFocus={(e) => e.target.select()} //全選択
        style={{ textAlign: 'right' }} //右寄せ
      />
    </>
  );
};

export default NumericFormatEntry_input;
